import React, { Component } from "react";
import PropTypes from "prop-types";
import VideoShimmer from "../shimmer/videoShimmer";
import withShimmer from "../shimmer/withShimmer";
import VideoCard from "./videoCard";
import { VideoPropTypes } from "../../constants/classPropTypes";
import "./videoList.scss";

class VideoList extends Component {
  generateCards = () => {
    const { videos } = this.props;

    return (
      videos && videos.map(item => <VideoCard key={item.id} video={item} />)
    );
  };

  render() {
    const { loadingStatus } = this.props;

    return (
      <div className="community-video-list row">
        {withShimmer(this.generateCards(), VideoShimmer, loadingStatus)}
      </div>
    );
  }
}

VideoList.propTypes = {
  videos: PropTypes.arrayOf(VideoPropTypes),
  loadingStatus: PropTypes.string.isRequired
};

VideoList.defaultProps = {
  videos: []
};

export default VideoList;
